import useUserPermissionsStore from "@/stores/useUserPermissionsStore";
import { Menu, Flex, Text } from "@mantine/core";
import { addToast, Button } from "@heroui/react";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

import { useEffect, useState } from "react";
import { FiMoreVertical } from "react-icons/fi";
import { api, queryClient } from "@/lib/api-client";

import { AppointmentCancelModal } from "@/pages/Dashboard/Calendar/components/calendar/AppointmentActionsDropdown/AppointmentCancelModal";
import RemoveCustomerFromAppointmentModal from "@/Components/AppointmentModal/components/RemoveCustomerFromAppointmentModal";

export const CustomerAppointmentActions = ({
  appointment,
}: {
  appointment: {
    appointmentId: number;
    isRepeating: boolean;
    isLinked: boolean;
    isPreScheduled: boolean;
    customerAppointment: {
      userAppointmentId: number;
      customerDidAttend: number;
    };
  };
}) => {
  useLingui();

  const permissions = useUserPermissionsStore((state) => state.permissions);

  const [menuOpened, setMenuOpened] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [
    isRemoveCustomerFromAppointmentModalOpen,
    setIsRemoveCustomerFromAppointmentModalOpen,
  ] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setMenuOpened(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { mutateAsync: updateCustomerAppointment } =
    api.customerAppointment.useUpdateCustomerAppointment();

  const handleToggleAttendance = async () => {
    try {
      const newStatus =
        appointment.customerAppointment.customerDidAttend === 1 ? -1 : 1;
      await updateCustomerAppointment({
        body: {
          customerDidAttend: newStatus,
        },
        customerAppointmentId:
          appointment.customerAppointment.userAppointmentId,
      });
      addToast({
        title:
          appointment.customerAppointment.customerDidAttend === 1
            ? t`Označen neprihod`
            : t`Razveljavljen neprihod`,
        description:
          appointment.customerAppointment.customerDidAttend === 1
            ? t`Stranka je bila označena kot odsotna`
            : t`Odsotnost stranke je bila razveljavljena`,
        color: "success",
      });
    } catch (error) {
      console.error(error);
      addToast({
        title: t`Napaka`,
        color: "danger",
      });
    }

    queryClient.invalidateQueries({
      queryKey: ["customer"],
    });
  };

  return (
    <>
      <Flex direction="column" align="flex-end" ml={"auto"} gap={"md"}>
        <Menu
          shadow="md"
          radius={"lg"}
          opened={menuOpened}
          onChange={setMenuOpened}
        >
          <Menu.Target>
            <Button isIconOnly size="sm" variant="light">
              <FiMoreVertical className="h-4 w-4" />
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            {permissions.manage_appointments && (
              <>
                <Menu.Item
                  color="red"
                  onClick={() => {
                    if (appointment.isPreScheduled) {
                      setIsRemoveCustomerFromAppointmentModalOpen(true);
                    } else {
                      setIsCancelModalOpen(true);
                    }
                  }}
                >
                  <Trans>Izbriši termin</Trans>
                </Menu.Item>
                <Menu.Item color="orange" onClick={handleToggleAttendance}>
                  {appointment.customerAppointment.customerDidAttend === 1 ? (
                    <Trans>Označi neprihod</Trans>
                  ) : (
                    <Trans>Razveljavi neprihod</Trans>
                  )}
                </Menu.Item>
              </>
            )}
          </Menu.Dropdown>
        </Menu>
      </Flex>
      <AppointmentCancelModal
        isOpen={isCancelModalOpen}
        onClose={() => {
          setIsCancelModalOpen(false);
          queryClient.invalidateQueries({
            queryKey: ["customer"],
          });
        }}
        appointmentId={appointment.appointmentId}
        isRepeating={appointment.isRepeating}
        isLinked={appointment.isLinked}
      />

      <RemoveCustomerFromAppointmentModal
        isOpen={isRemoveCustomerFromAppointmentModalOpen}
        onClose={() => setIsRemoveCustomerFromAppointmentModalOpen(false)}
        appointmentId={appointment.appointmentId}
        userAppointmentId={appointment.customerAppointment.userAppointmentId}
      />
    </>
  );
};
